import React from 'react'
import { Title } from '@winnin/winnin_ui.components.title'

import { T } from 'lib/tolgee'
import { UserStore } from 'stores'

import BlockedLinkWrapper from '../BlockedLinkWrapper'

export default function SubjectsTitle({ tolgeeKey, linkUrl, children }) {
  const isUserViewer = UserStore.getRole === 'viewer'
  return (
    <Title tag="h3" weight="semi">
      <T
        keyName={tolgeeKey}
        parameters={{
          link: <BlockedLinkWrapper className="TerritorySubjects-title" isClickBlocked={isUserViewer} to={linkUrl} />,
        }}
      >
        {children}
      </T>
    </Title>
  )
}
